import { useState, useEffect } from 'react';
import { resolveMediaDomainImageUrl } from '@pm2/common-utils';
import { preloadImage } from '@utils/common';

/**
 * Resolves a sitecore image url such that it always is relevant for the
 * currently required dimensions.
 */
function useMediaDomainUrl(url, getDesiredWidth) {
  const [resolvedUrl, setUrl] = useState(resolveMediaDomainImageUrl(url, typeof getDesiredWidth === "number" ? getDesiredWidth : getDesiredWidth()));
  const [isReady, setReady] = useState(false);

  // Ensures that the image responsively scales to the correct width on resizes
  useEffect(() => {
    const updateUrl = () => {
      setUrl(resolveMediaDomainImageUrl(url, typeof getDesiredWidth === "number" ? getDesiredWidth : getDesiredWidth()));
    };
    updateUrl();
    window.addEventListener("resize", updateUrl);
    window.addEventListener("orientationchange", updateUrl);
    return () => {
      window.removeEventListener("resize", updateUrl);
      window.removeEventListener("orientationchange", updateUrl);
    };
  }, [url, getDesiredWidth]);

  // Tracks the current state of the image, exposing whether or not loading has
  // finished.
  useEffect(() => {
    if (isReady) {
      return;
    }
    const preload = async () => {
      if (!resolvedUrl) {
        return;
      }
      await preloadImage(resolvedUrl);
      setReady(true);
    };
    preload().catch(err => console.error("useSiteCoreImageUrl(): Failed to preload image", err));
  }, [isReady, resolvedUrl]);
  return [resolvedUrl, {
    isReady
  }];
}

export { useMediaDomainUrl };
//# sourceMappingURL=media-domain-url.js.map
